"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INVERTED_DEFAULT_COLOR = -1;
exports.DIM_OPACITY = 0.5;